import type { ApiClient } from '../../../shared/api/api-client';

export type SuperadminPaymentItem = {
  id: number;
  organization_id: number;
  amount: number;
  amount_cents: number;
  currency: string;
  status: string;
  provider: string;
  reference_type: string | null;
  reference_id: number | null;
  provider_ref: string | null;
  created_at: string;
};

export type SuperadminPaymentsListDto = {
  items: SuperadminPaymentItem[];
  total: number;
};

export async function fetchSuperadminPayments(
  apiClient: ApiClient,
  params: Record<string, string>
): Promise<SuperadminPaymentsListDto> {
  const qs = new URLSearchParams(params).toString();
  const path = `/superadmin/payments${qs ? '?' + qs : ''}`;
  const res = await apiClient.request<unknown>(path, { method: 'GET' });
  return res as SuperadminPaymentsListDto;
}
